import type { ModelAssignButtonProps } from "./model-assign-button.type";

import { ActionButton } from "@/ui/action-button";

import { useModelAssignButton } from "./model-assign-button.hook";

export const ModelAssignButton = (props: ModelAssignButtonProps) => {
  const { hideButton, ...buttonProps } = useModelAssignButton(props);

  if (hideButton) return null;

  return <ActionButton action="assign" {...buttonProps} />;
};
